<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
會員中心       </p>
	</div>
   <div class="mem-full">
 <Center title='1' />
	
<div class="mem-con">
	<div class="cen-ord">
		<div class="address">
			<div class="men-l1" >
				<div class="re-tit">
						   <h4>訂單概述</h4>
				</div>
				<div class="re-con"  >
						<el-row>
							<el-col span="10">
								訂單號: {{news.orderId}}
							</el-col>
							<el-col span="6">
								狀態: {{news.statusInfo}}
							</el-col>
							<el-col span="8">
								訂貨時間 : {{news.dtTime}}
							</el-col>
						</el-row>	
						<div class="pass-step">
						<el-steps :active="active"   align-center>
						       <el-step title="待支付">
						     <img v-if="active==-5" src="../../assets/ic1.png" slot="icon"/>
						 
						        
						       </el-step>
						       <el-step title="待發貨">  <img v-if="active==2" src="../../assets/ic1.png" slot="icon"/>
						
							 </el-step>
						       <el-step title="待送達"> <img v-if="active==3" src="../../assets/ic1.png" slot="icon"/>
						  </el-step>
							 <el-step title="已收貨"> <img v-if="active==4" src="../../assets/ic1.png" slot="icon"/>
							</el-step>
							
						     </el-steps>
							</div>
							<div class="ord-tip1" v-if="active==-5" >
						<div><img src="../../assets/tip1.png" /></div>		訂單尚未付款。如果30分鐘內未付款，將自動取消
							</div>
							
							<div class="ord-sim">
							<el-row gutter="20">
								<el-col span="5" class="lt">
									訂單金額:
								</el-col>
								<el-col span="19">
									CN ¥ {{news.price}}(包含運費 CN ¥ {{news.yunfei}})
								</el-col>
							</el-row>
							<el-row gutter="20">
								<el-col span="5" class="lt">
									接收資訊: 
								</el-col>
								<el-col span="10">
									
										{{news.shouhuo_info.name}} {{news.shouhuo_info.address}}
								</el-col>
								<el-col span="9">
															
									<div class="h-button but2" v-if="news.status==-5||news.status==2" @click="ride=true">更改地址</div>
								</el-col>
							</el-row>
							<el-row gutter="20">
								<el-col span="5" class="lt">
									付款方式: 
								</el-col>
								<el-col span="19">
								<div v-if="news.pay_info.jifen">
							積分
								</div>
								<div v-if="news.pay_type==0">
									未支付
								</div>
								<div v-if="news.pay_type==2">
									微信支付
								</div>
								<div v-if="news.pay_type==3">
									支付宝支付
								</div>
								</el-col>
							</el-row>
							</div>
							<div class="ord-tip1">
							<div><img src="../../assets/tip.png" /></div>跟踪程式碼: <span v-if="news.fahuo_info.length>0">{{news.fahuo_info[0].company}}  {{news.fahuo_info[0].order_id}}</span>
								</div>
								
								<div class="add-for" v-if="ride">
								<div class="add-tit">
									<p>修改地址 <span v-if="news.status==2">(只更新一次)</span></p>
										<div class="h-button but2" @click="submitForm('ruleForm')">確定</div>
								</div>
								<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top"  size="mini">
									<el-row :gutter="20">
										 <el-col :span="12">
								  <el-form-item label="名字" prop="first_name">
								    <el-input v-model="ruleForm.first_name"></el-input>
								  </el-form-item>
								  </el-col>
								  <el-col :span="12">
								  <el-form-item label="姓" prop="last_name">
								    <el-input v-model="ruleForm.last_name"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								<el-row :gutter="20">
								 			 <el-col :span="12">
								<el-form-item label="國家/地區"  prop="country">
								   <el-select v-model="ruleForm.country" placeholder="Please fill in Country"  @change="country">
								     <el-option v-for="item in sun" :label="item.DESCRIPTION" :value="item.DESCRIPTION"></el-option>
									  
								   </el-select>
								 </el-form-item>
								  </el-col>
								  <el-col :span="12">
								  <el-form-item label="身份證" prop="identity_id">
								    <el-input v-model="ruleForm.identity_id" placeholder="China,Hong Kong,Macao and Taiwan must fill in the ID card number"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								 <el-row :gutter="20">
								 			 <el-col :span="12">
								  <el-form-item label="居住地" prop="address_info">
								    <el-input v-model="ruleForm.address_info"></el-input>
								  </el-form-item>
								  </el-col>
								  <el-col :span="12">
								  <el-form-item label="詳細地址" prop="address_line" >
								    <el-input v-model="ruleForm.address_line"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								 <el-row :gutter="20">
								 			 <el-col :span="12">
								  <el-form-item label="手機" prop="phone">
								    <el-input v-model="ruleForm.phone"></el-input>
								  </el-form-item>
								  </el-col>
								  <el-col :span="12" v-if="korean">
								  <el-form-item label="清關程式碼或出生日期" prop="korean_code" >
								    <el-input v-model="ruleForm.korean_code"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								 
															
														
														
								
								 <el-row>
															
								  </el-row>
								 <el-row :gutter="20">
								
								 </el-row>
								 
															
								 
								 
								  </el-form-item>
								</el-form>
								
								</div>
							
				</div>
			</div>
			
		</div>
		  <div class="address">
		  	<div class="men-l1" >
		  		<div class="re-tit">
		  				   <h4>商品清單</h4>
		  		</div>
		  		<div class="re-con"  >
					
							  <div class="cen-ord1">
								  <el-row>
									  <el-col span="10">
					產品</el-col>
					<el-col span="5"> 價格  </el-col>
					<el-col span="4"> 數 </el-col>
					<el-col span="5"> 小計</el-col>
								  </el-row>
							  </div>
					<el-row v-for="it in news.products">
						
									  <el-col span="10">
									 <el-row gutter='10'  class="mem-con-it">
											  <el-col span="10">
												  <img class="cen-ord2" :src="it.image" />
											  </el-col>
											  <el-col span="14">
											  		<div>{{it.title}}</div>
												
											  </el-col>
										  </el-row>
				</el-col>
					<el-col span="5"> CN ¥ {{it.price_sale}} </el-col>
					<el-col span="4">
						{{it.num}}
					</el-col>
				<el-col span="5">
					{{it.price_sale*it.num}}
				</el-col>
								  </el-row>
								  
								  
							<div class="ord-info">
								<el-row gutter="10">
									<el-col span="21" class="os">{{news.products.length}} 總金額項目:</el-col>
									<el-col span="3">CN ¥ {{fin}}</el-col>
								</el-row>
								<el-row gutter="10">
									<el-col span="21" class="os">運費:</el-col>
									<el-col span="3">CN ¥ {{news.yunfei}}</el-col>
								</el-row>
								
								<el-row gutter="10">
									<el-col span="21" class="os">積分:</el-col>
									<el-col span="3">CN ¥ {{news.pay_info.jifen}}</el-col>
								</el-row>
								<el-row gutter="10">
									<el-col span="21" class="os">優惠券:</el-col>
									<el-col span="3">CN ¥ {{news.pay_info.yhq}}</el-col>
								</el-row>
								<el-row gutter="10">
									<el-col span="21" class="os"><b>訂單金額:</b></el-col>
									<el-col span="3"><b>CN ¥ {{news.price}}</b></el-col>
								</el-row>
							</div>
							<div class="ord-int">
								<div class="h-button" v-if="news.status==-5" @click="sandRed">支付</div>
								<!-- <div class="h-button but2" v-if="news.status==-5" @click="cancel">取消訂單</div> -->
								<div class="clear"></div>
							</div>
		  		</div>
		  	</div>
	
		  </div>
	</div>



</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center


  },
  data() {
    return {
		page:1,
		pagenum:100,
		moren:false,
		activeName: '0',
		sun:'',
		active:1,
		id:'',
		total:'',
		fin:0,
		ride:false,
		news:'',
         korean:false,
            ruleForm: {
         	id:'',
            	first_name:'',
            	last_name:'',
            	phone:'',
            	country:'',
            	address_info:'',
            	address_line:'',
            	korean_code:'',
         	identity_id:''
           
                
                  },
                  rules: {
                  	
                  	   first_name: [
                  	    { required: true, message: '請填寫名字', trigger: 'blur' },
                  ],last_name: [
                  	    { required: true, message: '請填寫姓', trigger: 'blur' },
                  ],phone: [
                  	    { required: true, message: '請填寫手機', trigger: 'blur' },
                  ],country: [
                  	    { required: true, message: '請填寫國家', trigger: 'change' },
                  ],address_line: [
                  	    { required: true, message: '請填寫詳細地址', trigger: 'blur' },
                  ],address_info: [
                  	    { required: true, message: '請填寫居住地', trigger: 'blur' },
                  ]
                   
                    }
          };
  },  mounted() {
	  
	  this.id = this.$route.query.id
this.ruleForm.id=this.id
		this.sandMate();
		this.sandCase();
		},methods: {
			
	submitForm(formName) {
			if(this.ruleForm.country=='中国'||this.ruleForm.country=='中国香港'||this.ruleForm.country=='中国台湾'||this.ruleForm.country=='中国澳门'){
								  if(this.ruleForm.identity_id==''){
									   this.ins=true
								  }else{
												    this.ins=false
											  }
							
			}
			  
			  if(this.ins){
				  this.$message.error("請填寫身份證號");
				  return
			  }
				    
				      
	       this.$refs[formName].validate((valid) => {
	         if (valid) {
	        this.$axios({
	          method: "post",
	          url: "service.php?action=orders_editAddress",
	          data: this.ruleForm,  
	        }).then((res) => {
	        	let data=res.data;
	        			
	        	if(data.code==1){
							
						this.$message.success(data.message);
						this.sandMate()
						this.ride=false
	        	}else{  
							this.$message.error(data.message);
							      this.ride=false
						}
	         
	        });
					 
					 
	         } else {
	          
	           return false;
	         }
	       });
	     },
			  full(){
				  if(this.moren){
					  this.ruleForm.moren= 1
				  }else{
					   this.ruleForm.moren= 0
				  }
			
			  },   country(){  
			   				  if(this.ruleForm.country=='韩国'){
								
			   					this.korean=true
			   				
			   				  }
							  
							if(this.ruleForm.country=='中国'||this.ruleForm.country=='中国香港'||this.ruleForm.country=='中国台湾'||this.ruleForm.country=='中国澳门'){
										  					  if(this.ruleForm.identity_id==''){
										  						   this.ins=true
										  					  }else{
										  								 this.ins=false
										  								  }
										  				
							}
			   },
			  sandRed(){
				  
				   this.$router.push({ path: "/product/pay?id="+this.id });	
			  // 	this.$axios({
			  // 	  method: "post",
			  // 	  url: "service.php?action=paypal_pay",
			  // 	  data: {order_id:this.id},  
			  // 	}).then((res) => {
			  // 		let data=res.data;
			  
			  // 		if(data.code==1){
			  // 		window.open(data.data.link)
			  				
			  // 		}
			  	 
			  // 	});
			  
			  },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },pick(item){
							this.page=item;
							this.sandMate()
						},
			 sandMate(){
			 	this.$axios({
			 	  method: "post",
			 	  url: "service.php?action=orders_detail",
			 	  data: {id:this.id},  
			 	}).then((res) => {
			 		let data=res.data;
			 
			 		if(data.code==1){
			 	
			 							
			 			this.news=data.data;
						this.news.products.forEach((item,index)=>{
							this.fin+=item.price_sale*item.num
						})
						this.fin=Number(this.fin).toFixed(2)
						this.active=data.data.status
			 			this.total=data.count
			 			this.ruleForm.first_name=data.data.shouhuo_info.info.first_name
			 			this.ruleForm.last_name=data.data.shouhuo_info.info.last_name
			 			this.ruleForm.country=data.data.shouhuo_info.info.country
			 			this.ruleForm.identity_id=data.data.shouhuo_info.info.ID
			 			this.ruleForm.address_info=data.data.shouhuo_info.info.所在地区
			 			this.ruleForm.address_line=data.data.shouhuo_info.info.详细地址
			 			this.ruleForm.phone=data.data.shouhuo_info.info.手机号
			 			this.ruleForm.korean_code=data.data.korean_code
			 			if(this.ruleForm.country=='South Korea'){
			 											
			 				this.korean=true
			 						   				
			 			}
			 		}
			 	 
			 	});
			 
			 }, cancel(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_qxOrder",
			  	  data: {order_id:this.id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  			
			  		this.$message.success(data.message);
			  			this.sandMate();		
			  		}else{  
			  			this.$message.error(data.message);
			  			      
			  		}
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }, handleClick() {
				  this.sandMate()
      
      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 136px;
			height: 30px;
			line-height:30px;
			background: #000;
			color: #FFFFFF;
			float: right;
			margin-left: 30px;

		}
		.h-button:hover{
			background-color: #333333;
		}
		.but2{
			background: #E8E8E8;
			color: #0A0A0A;
		}
		.but2:hover{
		
			color: #FFFFFF;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.address{
	.re-con{
		font-size: 15px;
		.pass-step{
			margin: 50px 0;
		}
		.ord-sim{
			margin-top: 30px;
			line-height: 30px;
			font-size: 15px;
			color: #484848;
			margin-bottom: 20px;
			.lt{
				text-align: right;
			}
		}
		.ord-tip1{
			display: flex;
			align-items: center;
			background: #D2D2D2;
			padding: 6px 15px;
			color: #0A0A0A;
			img{
				margin-right: 10px;
			}
		}
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}
.member{
	width: 247px;
	height: 687px;
	background: #F8F8F8;
	padding: 30px;
	h5{
		line-height: 50px;
		background: url(../../assets/bot1.png) no-repeat bottom left;
	}
	.con{
		li{
			border-bottom:1px solid #eeeeee;
			padding: 20px;
		}
		h6{
			line-height: 40px;
		}
		p{
			display: flex;
			line-height: 40px;
			align-items: center;
			color: #777777;
			span{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #636363;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.act{
			color: #000000;
		}
	}

}
.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		margin-bottom: 20px;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
	margin-top: 30px;
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	.add-tit{
		display: flex;
		justify-content: space-between;
		p{
			font-size: 16px;
			span{
				font-size: 14px;
			}
		}
		margin-bottom: 20px;
	}

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
.cen-ord1{
background: #F8F8F8;
padding: 20px;
margin-bottom: 20px;
}
.cen-ord2{
	width: 100%;
}
.cen-ord3{
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content:space-evenly;
}
	.page{
		text-align: center;
		margin:50px auto;
	}
	.mem-con-it{
		height: 100px;
	}
.ord-info{
	line-height: 30px;
	font-size: 16px;
	.os{
		text-align: right;
	}
}
.ord-int{
	margin: 20px 0;
}
</style>